import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import { StyledLabel, StyledRadio, Wrapper } from "./Radio.styles";

const BaseRadio = (props) => {
    return <input {...props} type="radio" />;
};

const Radio = React.forwardRef(({ label, checked, disabled, ...rest }, ref) => {
    const RadioControl = (
        <StyledRadio
            {...rest}
            checked={checked}
            disabled={disabled}
            type="radio"
            ref={ref}
        />
    );
    return (
        <Wrapper $disabled={disabled}>
            {label ? (
                <StyledLabel
                    spacing="Zero_5"
                    align="center"
                    $disabled={disabled}
                >
                    {RadioControl}
                    <Text variant={checked ? "Body_2_2" : "Body_2_1"}>
                        {label}
                    </Text>
                </StyledLabel>
            ) : (
                <BaseRadio {...rest} />
            )}
        </Wrapper>
    );
});

Radio.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
};

export default Radio;
